import { useGetCanCallQuery } from '@reducers/callsAPI';

const useHasCallAccess = (botAccountId?: number) => {
  const { data, isLoading, isFetching } = useGetCanCallQuery(
    { lineId: botAccountId ?? 0 },
    { skip: !botAccountId, refetchOnMountOrArgChange: true }
  );

  return {
    hasCallAccess: Boolean(data?.canCall),
    isLoading: isLoading || isFetching,
  };
};

export default useHasCallAccess;
